import type { ConfigSection } from "@eweadn-qiankun/shared-types";
import type {
  CommunityPreviewDeviceMeta,
  FullBoardConfigData,
} from "@eweadn-qiankun/shared-types";
import CommunityPreviewStage from "./CommunityPreviewStage";
import KeyboardLightingSection from "./panels/KeyboardLightingSection";
import KeyboardTriggerSection from "./panels/KeyboardTriggerSection";
import KeyboardChangeKeySection from "./panels/KeyboardChangeKeySection";
import KeyboardAdvancedKeySection from "./panels/KeyboardAdvancedKeySection";
import KeyboardPerformanceSection from "./panels/KeyboardPerformanceSection";

export interface CommunityKeyboardPreviewProps {
  meta: CommunityPreviewDeviceMeta;
  configData: FullBoardConfigData;
  activeSection: ConfigSection;
  readOnly?: boolean;
  /** 0=Win，1=Mac */
  currentDeviceSystem?: number;
}

/** 键盘配置只读预览（对齐技术方案 CommunityKeyboardPreview） */
export default function CommunityKeyboardPreview({
  meta,
  configData,
  activeSection,
  readOnly: _readOnly = true,
  currentDeviceSystem = 0,
}: CommunityKeyboardPreviewProps) {
  const section = (() => {
    switch (activeSection) {
      case "lighting":
        return (
          <KeyboardLightingSection
            meta={meta}
            configData={configData}
            currentDeviceSystem={currentDeviceSystem}
          />
        );
      case "trigger":
        return (
          <KeyboardTriggerSection
            meta={meta}
            configData={configData}
            currentDeviceSystem={currentDeviceSystem}
          />
        );
      case "changeKey":
        return (
          <KeyboardChangeKeySection
            meta={meta}
            configData={configData}
            currentDeviceSystem={currentDeviceSystem}
          />
        );
      case "advancedKey":
        return (
          <KeyboardAdvancedKeySection
            meta={meta}
            configData={configData}
            currentDeviceSystem={currentDeviceSystem}
          />
        );
      case "performance":
        return (
          <KeyboardPerformanceSection meta={meta} configData={configData} />
        );
      default:
        return null;
    }
  })();

  return <CommunityPreviewStage>{section}</CommunityPreviewStage>;
}
